/**
 * A constant object that holds various keys and values related to stickers in the CometChat UI Kit.
 * This object is frozen to prevent any modifications to its properties.
 */

export const StickersConstants = Object.freeze({
    sticker: "extension_sticker",
    default_stickers: "defaultStickers",
    custom_stickers: "customStickers",
    stickers: "stickers",
    data: "data",
    custom_data: "customData",
    sticker_url: "sticker_url",
    sticker_name: "sticker_name",
    get: "GET",
    v1_fetch: "v1/fetch"
})